(ns teamoesterreich.admin-mode.map.map-polygon-picker
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.log :as log]))

(defn new-polygon []
  (js/google.maps.Polygon. #js {:center #js {:lat 48.185319 :lng 16.359107}
                                :paths #js[]
                                :strokeColor "#FF0000"
                                :strokeOpacity 0.8
                                :strokeWeight 2
                                :fillColor "#FF0000"
                                :fillOpacity 0.1}))
(defn init-new-polygon []
  (js/google.maps.Polygon. #js {:center #js {:lat 48.185319 :lng 16.359107}
                                :paths #js[]
                                :strokeColor "#FFA000"
                                :strokeOpacity 0.8
                                :strokeWeight 2
                                :fillColor "#FFF000"
                                :fillOpacity 0.1}))

(defn add-polygon-new-point! [!path lat lng]
  (let [path @!path]
    (.push path #js {:lat lat :lng lng})
    (reset! !path path)))


(defn pick-polygon-gmap-component [!st & [initial-path]]
  (js/console.log "Mount gmap-polygon-picker "  initial-path)
  (let [!path (r/cursor !st [:path])
        gmap    (atom nil)

        options (clj->js {"center" (js/google.maps.LatLng. 48.17, 11.6)
                          "zoom" 7.4})
        update  (fn [parm]
                  ;(js/console.log "Update Gmap called (sel)" @!path)
                  (do
                    ;(.setCenter (:map @gmap) (js/google.maps.LatLng. (:map-x @!st) (:map-y @!st)))
                    (.setMap (:polygon @gmap) (:map @gmap))
                    ;(.setPosition (:polygon @gmap) )
                    )
                  (when (count initial-path)
                    (.setPath (:initial-polygon @gmap) initial-path)
                    (.setMap (:initial-polygon @gmap) (:map @gmap)))
                  (when (:polygon @gmap)
                    (.setPath (:polygon @gmap) @!path)
                    (.setMap (:polygon @gmap) (:map @gmap)))

                  (.setOptions (:map @gmap)  (clj->js {"draggableCursor" (if (and @!st (:pickMode @!st)) "crosshair" "pointer")}))
                  )]
    ;(add-watch !st :on-change (fn [] (js/console.log "Watch !st" @!st) (update {})))
    (r/create-class
      {:reagent-render       (fn [] [:div#map-canvas
                                     {:style {:border (if (and @!st (:pickMode @!st)) "2px solid red" "2px solid white")
                                              }}])
       :component-did-mount  (fn [comp]
                               (let [canvas (.getElementById js/document "map-canvas")
                                     gm (js/google.maps.Map. canvas options)]
                                 (reset! gmap {:map gm :polygon (new-polygon) :initial-polygon (init-new-polygon)}))
                               (update comp)
                               (js/google.maps.event.addListener (:map @gmap) "click"
                                                                 (fn [e]
                                                                   (let [clicked-location (.-latLng e)
                                                                         query #js {:fields   ["formatted_address"]
                                                                                    :radius   "500"
                                                                                    :location clicked-location}]
                                                                     (when (:pickMode @!st)
                                                                       (log/debug "map clicked " (.lat clicked-location) (.lng clicked-location) (:polygon @gmap))
                                                                       (add-polygon-new-point! !path (.lat clicked-location) (.lng clicked-location)))
                                                                     (update comp))
                                                                   ))

                               )
       :component-did-update (fn [params]
                               (update params)

                               )

       :display-name         "gmap-component"})))


(defn pick-polygon-test []
  [pick-polygon-gmap-component (r/atom {:pickMode true :path #js []})])